////////////////////////////////////////////////////////////////////////////////
//
// Kiosk API module
//
////////////////////////////////////////////////////////////////////////////////

import ApiService from "@/services/api.service";

////////////////////////////////////////////////////////////////////////////////

const entity = {
    /**
     * Get all accounts
     * @returns {Promise<AxiosResponse<any>>}
     */
    load: () => ApiService.getT('config'),

    /**
     * Save the config data
     * @return {Promise<AxiosResponse<any>>}
     */
    save: (data) => {
        const putData = { operator: { $set: data } };
       //console.log('Payload:', putData); // Debug the payload sent to the backend

        return ApiService.putT('config', putData)
    },
     uploadEntityFile(formData) {
        return ApiService.postT('file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
     
     listEntityFiles(entityId) {
                return ApiService.getT('file', {
                    params: {
                        entity_id: entityId,
                        level: 'entity'
                    }
                });
            },
            
     deleteEntityFile(fileId) {
        return ApiService.deleteT(`file/${fileId}`);
    },
     
     deleteAllEntityFiles(entityId)  {
        return ApiService.deleteT('files', {
            params: {
                level: 'entity',
                entity_id: entityId
            }
        });
    },
    uploadEntityFirmware(formData) {
           return ApiService.postT('firmware', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          });
        },
    listEntityFirmware(entityId, deviceType = 'CC2') {
       return ApiService.getT(`firmware/list/${deviceType}`, {
        params: {
            level: 'entity',
            entity_id: entityId
        }
        });
           },
    deleteEntityFirmware(firmwareId) {
        return ApiService.deleteT(`firmware/${firmwareId}`)
          },

     deleteAllEntityFirmware(entityId,deviceType) {
        return ApiService.deleteT('firmware', {
        params: {
            level: 'entity',
            entity_id: entityId,
            device_type: deviceType
        }
    });
        },
        uploadEntityIcon(formData) {
    return ApiService.postT('icon', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
},
listEntityIcons(entityId) {
    return ApiService.getT('icon', {
        params: { entity_id: entityId, level: 'entity' }
    });
},
deleteEntityIcon(iconId) {
    return ApiService.deleteT(`icon/${iconId}`);
},
deleteAllEntityIcons(entityId) {
    return ApiService.deleteT('icons', {
        params: { level: 'entity', entity_id: entityId }
    });
}
     
}

export default entity;